module.exports = __webpack_public_path__ + "img/prize-05.375af039.png";